var exports = {
  "Q": "AttachmentEditModal.module__content___MWpzVj",
};

module.exports = exports;
